import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { usePageProgress } from "../../lib/motion";
import Header from "./Header";
import Footer from "./Footer";
import BookingDrawer from "./BookingDrawer";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // jsdom has no scrollTo; guard so tests don't warn
    if (typeof window.scrollTo === "function") window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function Layout() {
  const progress = usePageProgress();

  return (
    <>
      <a href="#main" className="skip">پرش به محتوای اصلی</a>

      <div className="pbar" aria-hidden="true">
        <div className="pbar__fill" style={{ transform: `scaleX(${progress.toFixed(3)})` }} />
      </div>

      <ScrollToTop />
      <Header />
      <main id="main">
        <Outlet />
      </main>
      <Footer />
      <BookingDrawer />
    </>
  );
}
